export default {"src":"https://images-cdn.curipod.com/d-8a4f32ab/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};